// VehicleList.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { sanityClient } from "../lib/sanityClient";
import VehicleCard from "./VehicleCard";
import { useTranslation } from "react-i18next";

const VehicleList = ({ categorySlug }) => {
  const { lang } = useParams();
  const { t } = useTranslation();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVehicles = async () => {
      const query = `*[_type == "vehicle" && references(*[_type == "category" && slug.current == $slug]._id)]{
        _id,
        title,
        slug,
        price,
        condition,
        primaryImage,
        categories[]->{slug}
      }`;
      const data = await sanityClient.fetch(query, { slug: categorySlug });
      setVehicles(data);
      setLoading(false);
    };

    fetchVehicles();
  }, [categorySlug, lang]); // Added lang to dependency array

  const getLocalizedText = (localizedField) =>
    localizedField?.[lang] || localizedField?.en || t("untitled");

  if (loading) return <p className="text-center text-gray-600">{t("loading_cars")}</p>;
  if (vehicles.length === 0) return <p className="text-center text-gray-500">{t("no_cars_found")}</p>;

  return (
    <div className="container mx-auto px-4 py-6">
      <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
        {t("new_and_used_cars_for_sale")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {vehicles.map((vehicle) => (
          <VehicleCard
            key={vehicle._id}
            vehicle={{
              ...vehicle,
              localizedTitle: getLocalizedText(vehicle.title),
            }}
            lang={lang}
          />
        ))}
      </div>
    </div>
  );
};

export default VehicleList;